import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import config from "../config.json";
import axios from "axios";
import { useUser } from "../contexts/UserContext";

const CustomerTable = () => {
	const navigate = useNavigate();
	const { userRole } = useUser();
	const [customers, setCustomers] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const handleLogout = () => {
		localStorage.removeItem("authToken");
		localStorage.removeItem("userData");
		navigate("/login");
	};

	useEffect(() => {
		if (userRole !== "admin") {
			handleLogout();
		}
	}, [userRole, navigate, handleLogout]);

	useEffect(() => {
		const fetchCustomers = async () => {
			try {
				const response = await axios.get(
					`${config.baseURL}middlewareCustomers`,
					{
						headers: {
							...config.headers,
						},
					}
				);
				setCustomers(response.data);
			} catch (error) {
				console.error("Error fetching customers:", error);
			}
		};

		fetchCustomers();
	}, []);

	const columns = [
		{
			field: "Name",
			headerName: "Name",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "Email",
			headerName: "Email",
			flex: 1,
			minWidth: 200,
		},
		{
			field: "Phone",
			headerName: "Phone",
			flex: 1,
			minWidth: 100,
		},
		{
			field: "Total_Transactions_Purchased",
			headerName: "Total Transactions Purchased",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "Total_Transactions_Used",
			headerName: "Total Transactions Used",
			flex: 1,
			minWidth: 150,
		},
		{
			field: "Auto_Renew",
			headerName: "Auto Renew?",
			flex: 1,
			minWidth: 100,
			renderCell: (params) => (params.value ? "Yes" : "No"),
		},
		{
			field: "Renew_Threshold",
			headerName: "Renew Threshold",
			flex: 1,
			minWidth: 100,
		},
		{
			field: "actions",
			headerName: "Actions",
			flex: 1,
			minWidth: 50,
			headerAlign: "center",
			align: "center",
			renderCell: (params) => (
				<Tooltip title="Edit Customer">
					<IconButton onClick={() => handleEdit(params.row)}>
						<EditIcon style={{ color: "black" }} />
					</IconButton>
				</Tooltip>
			),
		},
	];

	const handleEdit = (row) => {
		navigate(`/customer-details?customerId=${row.id}`);
	};

	return (
		<div>
			<Button
				variant="contained"
				sx={{
					backgroundColor: "#FF7600",
					color: "#2c2d2d",
					marginBottom: "20px",
					"&:hover": {
						backgroundColor: "#e26a00",
					},
				}}
				onClick={() => navigate("/customer-details")}
			>
				<strong>+ New Customer</strong>
			</Button>

			<div style={{ height: 500, width: "100%", marginTop: 20 }}>
				<DataGrid
					rows={customers}
					columns={columns}
					pageSize={rowsPerPage}
					rowsPerPageOptions={[5, 10, 20]}
					onPageChange={(params) => setPage(params.page)}
					onPageSizeChange={(params) => setRowsPerPage(params.pageSize)}
					disableSelectionOnClick
					autoPageSize
					sx={{
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: "#f0f0f0",
							fontSize: "14px",
							fontWeight: "bold",
						},
						"& .MuiDataGrid-columnHeaderTitle": {
							fontWeight: "bold",
						},
					}}
				/>
			</div>
		</div>
	);
};

export default CustomerTable;
